export default {
    firstToCreate: '成为第一个在此论坛创建主题的人',
    firstToPostInCategory: '成为第一个在此类别中发帖的人',
    firstToRespondToTopic: '成为第一个回应此主题的人！',
    createNewThread: '创建新主题',
    thread: '主题',
    viewThread: '查看主题',
    replies: '回复',
    noReplies: '暂无回复',
    reply: '回复',
    _reply: '回复',
    ReplyTo: '回复给',
    replyToThisQuestion: '回复此问题',
    onceRepliedModeratorMayRespond: '一旦您回复，论坛版主可能会回复您的回应',
    onceRepliedCanViewResponses: '一旦您回复，您可以查看其他参与者的回复',
    loadingResponses: '正在加载回复',
    hideXReplies: '隐藏 {count} 条回复',
    showXReplies: '显示 {count} 条回复',
    hideMostRecentReplies: '隐藏最新回复',
    showMostRecentReplies: '显示最新回复',
    post: '发布',
    message: '消息',
    typeMessage: '输入消息',
    addPost: '添加帖子',
    addMessage: '添加消息',
    editPost: '编辑帖子',
    editPostWithMedia: '编辑带有媒体的帖子',
    createPostWithMedia: '创建带有媒体的帖子',
    deleteMessage: '删除消息',
    deleteMessageConfirm: '您确定要删除此消息吗？',
    pinPost: '置顶帖子',
    media: '媒体',
    uploadMedia: '上传媒体',
    categories: '类别',
    goBack: '返回',
    goBackPrevious: '返回上一页',
    goBackToCategory: '返回 {name} 类别',
    loadingLatestThreads: '正在加载最新主题',
    loadingDiscussionForum: '正在加载讨论论坛',
    dontShowAgainForTask: '此任务不再显示',
    title: '标题',
    beTheFirst: '成为第一个回复此线程的人'
};
